import { render, staticRenderFns } from "./OrganisationRegistration.vue?vue&type=template&id=1945dcfb&scoped=true&"
import script from "./OrganisationRegistration.vue?vue&type=script&lang=js&"
export * from "./OrganisationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationRegistration.vue?vue&type=style&index=0&id=1945dcfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945dcfb",
  null
  
)

export default component.exports